import { useEffect, useLayoutEffect } from 'react';

/**
 * React warns if using `useLayoutEffect` server side: this fixes the warning by
 * using `useEffect` when called on server.
 *
 * @see https://usehooks-ts.com/react-hook/use-isomorphic-layout-effect
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
